/**
 * zh-cn
 * @author wwl
 * @created 2023/11/6
 * @modified 2023/11/6
 */
export default {
  // 通用模块
  common: {
    site_title: '展会网',
    more: '更多',
    packUp: '收起',
    view: '查看',
    internation: '国际',
    china: '国内',
    industry: '行业',
    fair: '展会',
    expo: '展会',
    concurrentFair: '同期展会',
    vote: '门票',
    search: '搜索',
    boothInquiry: '展位咨询',
    ticketBooking: '门票预定',
    exhibitorECatalog: '展商/电子会刊查看',
    booth: '展位',
    ticket: '门票',
    catalog: '会刊'
  },
  pagination: {
    previousPage: '上一页',
    nextPage: '下一页',
    goTo: '前往',
    page: '页',
    confirm: '确定'
  },
  innerChain: {
    hotArea: '热门地区',
    hotIndustry: '热门行业',
    hotExhibition: '热门展会'
  },
  // 菜单
  menu: {
    home: '首页',
    domestic: '国内展会',
    international: '国际展会',
    exhibitionInfo: '展会资讯',
    conventionCenter: '会展中心',
    cooperate: '展会合作',
    visa: '签证',
    keywordPlaceholder1: '请输入关键字',
    keywordPlaceholder2: '搜索词长度超过 50 字数限制，请删减后重试',
    keywordPlaceholder3: '请输入汉字或字母',
    keyword_error1: '只能搜索汉字、数字或字母',
    keyword_error2: '搜索词长度超过 50 字数限制，请删减后重试',
    top: {
      ticket: '我的门票',
      fair: '我的展会',
      industry: '我的行业',
      leaderboard: '排行榜',
      sitemap: '网站地图',
      signup: '登录/注册',
      order: '我的订单',
      quit: '退出'
    }
  },
  // 页脚
  footer: {
    about: '关于我们',
    help: '帮助中心',
    contact: '联系我们',
    highpay: '高薪诚聘',
    agreement: '服务协议',
    payment: '支付方式',
    cooperation: '展会合作',
    ICP_recordNum: 'ICP备案号:浙ICP备18015679号',
    networkSecurity: '浙公网安备 33011002013432号',

    us_collaborate: '和我们合作',
    customer: '在线客服',
    booth_consult: '展位咨询',
    viewer_consult: '观众咨询',
    work_time: '周一至周日',
    work_time2: '周一至周五',
    friendship_link: '友情链接：(互换友链请加QQ: 61882907)',

    WeChatofficial: '微信公众号',
    WeChat_applet: '微信小程序',
    desc: '请使用手机微信扫码关注',
    scan_follow: '扫码关注公众号',
    scan_openApplet: '扫码打开小程序'
  },
  // 首页模块
  home: {
    top_container: {
      slogan: '全球展会展位预订、门票预订',
      inputPlaceholder: '国家，城市，行业，展会名称'
    },
    hot_city: {
      title: '热门展会城市：',
      city1: '上海',
      city2: '深圳',
      city3: '广州',
      city4: '北京',
      city5: '香港',
      city6: '德国',
      city7: '日本',
      city8: '美国',
      city1_hover: '上海展会',
      city2_hover: '深圳展会',
      city3_hover: '广州展会',
      city4_hover: '北京展会',
      city5_hover: '香港展会'
    },
    kindTitle: '展会行业分类',
    hot_recommend: {
      hot_title: '推荐热门展会',
      moreButton: '更多',
      international_hover: '国际展会',
      domestic_hover: '国内展会',
      internationalTitle: '国际展会·即将开展',
      domesticTitle: '国内展会·即将开展',
      distance: '距离',
      day: '天',
      openness: '开展中...',
      timeUpdate: '时间更新中...',
      newTrends_title: '最新动态',
      exhibitionInfo_hover: '展会资讯',
      nuwInfo_title: '最新资讯',
      newExhibition_title: '最新展会',
      hot_country_title: '热门国家',
      country_suffix3: '展览会',
      country_suffix2: '展览',
      country_suffix1: '展',
      service_1: '全球展会资源',
      service_2: '专属服务顾问',
      service_3: '一站式服务',
      service_4: '快速精准匹配',
      service_5: '覆盖99个国家'
    },
    popularRegions: '热门地区',
    hotIndustries: '热门行业',
    topExhibitions: '热门展会'
  },

  // 固定侧边栏
  fixed_sidebar: {
    phone: '电话',
    booth: '展位咨询',
    viewer: '观众咨询',
    customer: '客服',
    online_customer: '在线客服',
    my: '我的',
    vote: '门票',
    cooperate: '展位\n合作'
  },

  // 展会模块
  exhibition: {
    industryTitle: '展会行业分类',
    concurrentFair: '展会同行业展会',
    filters: {
      keyword: '关键词',
      selectedCondition: '已选条件',
      area: '区域',
      region: '地区',
      city: '城市',
      hotCity: '热门城市',
      domestic: '国内展会',
      domesticExh: '国内展会(含港澳台)',
      international: '国际展会',
      all: '全部',
      more: '更多',
      packUp: '收起',
      dateFormat: 'YYYY年MM月'
    },
    scale: '展会规模',
    heatSort: '热度排序',
    timeSort: '时间排序',
    recommendedExhibition: '推荐展会',
    industryNews: '展会资讯',
    time: '展会时间',
    latestNews: '最新展会动态资讯',
    timeUpdate: '时间更新中...',
    openness: '开展中...',
    distance: '距离',
    day: '天',
    year: '年',
    periods: '届',
    booth: '展位',
    ticket: '门票',
    exhibitor: '会刊',
    hot: '热门',
    recommended: '推荐',
    winnow: '精选',
    visitorViews: '人浏览',
    updating: '努力更新中...',
    postponed: '时间变更',
    cancelled: '取消',
    notNewTime: '时间待定',
    visitorCount: '观众人数',
    daysToOpen: '距离开展还有',
    ongoing: '开展中...',
    nextEditionUpdate: '下届时间更新中...',
    standardBooth: '标准展位',
    bareSpace: '光地展位',
    subscribed: '已订阅',
    subscribe: '订阅',
    recommendedExhibitions1: '为了满足您的需求，我们为您推荐了',
    recommendedExhibitions2: '同期其他展会的信息，希望能对您有所帮助',
    servicePrompt: '如需参展/参观可咨询在线客服',
    contactCustomerService: '咨询客服'
  },
  // 展会详情页
  exhibitionDetail: {
    scaleScore: '规模度',
    specialityScore: '专业度',
    evaluateScore: '评价度',
    audienceScore: '观众度',
    marketScore: '市场度',
    exhibitionAddress: '举办地址',
    exhibitionHall: '举办展馆',
    exhibitionArea: '展览面积',
    openingHours: '开闭馆时间',
    exhibitorsNumber: '展商数量',
    exhibitorsNumberUnit: '家',
    audienceSize: '观众数量',
    audienceSizeUnit: '人',
    cycle: '举办周期',
    boothMap: '展位　图',
    getBoothMap: '获取展位图',
    subsidy: '补贴',
    yes: '有',
    samePeriodExhibition: '同期举办',
    viewTime: '查看展会时间',
    viewMap: '查看地图',
    exhibitionHallNumber: '展馆号',
    travelReminder: '出行提醒',
    standardBooth: '标准展位',
    bareSpaceBooth: '光地展位',
    projectManagerQuotation: '项目经理报价',
    viewPrice: '查看价格',
    lastDay: '展会最后一天需在14:00前入场',
    ticketDescription: '购票须知',
    exhibitionHighlights: '展会要点',
    boothConsult: '展位咨询',
    exhibitorPeriodical: '展商/电子会刊',
    scaleRating: '规模度',
    professionalRating: '专业度',
    evaluationRating: '评价度',
    spectatorRating: '观众度',
    marketRating: '市场度',
    distance: '距离开展',
    day: '天',
    exhibitionInProgress: '开展中...',
    nexttermTimeRenew: '下届时间更新中',
    boothApply: '展位申请',
    ticketReservation: '门票预订',
    exhibitorDirectory: '展商名录',
    freeForALimitedTime: '门票限时免费',
    tourItinerary: '展团行程',
    weChatShare: '小程序分享',
    hotelReservation: '酒店预订',
    exhibitionPicture: '展会视图',
    visaProcessing: '签证办理',
    poster: '生成海报',
    view: '浏览',
    exhibitionIntroduction: '展会介绍',
    exhibitsRange: '展品范围',
    relatedExhibition: '相关展会',
    industry: '所属行业',
    organizer: '主办单位',
    exhibitorNumber: '展商数量',
    exhibitionInvitationLetter: '招展函',
    buyerData: '买家数据',
    exhibitionHall2: '展馆',
    attend: '人有兴趣参加',
    exhibitionReminder: '展会提醒',
    warmReminder: '温馨提醒',
    warmReminderContent:
      '展会举办时间和地点具有一定变更风险，请以收到的电子门票凭证为准，聚展也将为预订门票的用户提供电话、短信通知提醒，避免用户的出行损失。',
    notificationReminder: '通知提醒',
    addReminder: '添加到我的展会提醒',
    viewReminder: '查看我的提醒',
    openNotification: '开启订阅通知',
    closeNotification: '关闭订阅通知',
    changeNotice: '展会时间变动、交通信息随手查',
    professionalAudience: '专业观众门票预订',
    electronic_journal: '展商/电子会刊查看订阅',
    reserveButton: '立即预订',
    ImmediateGet: '立即获取',
    relatedHotspotRecommendation: '相关热点推荐',
    form1: {
      companyName: '请输入公司名称(必填)',
      name: '请输入联系人姓名(必填)',
      phone: '请输入联系电话(必填)',
      email: '请输入邮箱(选填)',
      remark: '请输入备注(选填)',
      submit: '提交',
      cancel: '取消'
    }
  },
  // 展位申请页面
  boothApply: {
    nav: '展位预订/展位图获取',
    step1: '选择服务类型',
    step2: '确认公司信息',
    step3: '提交服务订单',
    step4: '客户跟进对接',
    fairTime: '展会时间',
    form: {
      input: '请输入(必填)',
      scale: '请选择展位面积(必填)',
      submit: '立即提交'
    },
    tip: {
      title: '展位申请须知',
      n1: '展位咨询提交后，工作人员将在1-2个工作日内根据预留的联系方式与您进行一对一对接',
      n1_1: '展位申请提交后，工作人员将在1 - 2个工作日内根据预留的联系方式与您进行一对一对接',
      n2: '提交公司营业执照',
      n3: '提交产品图片及名称',
      n4: '接收展会介绍文件及展位图',
      n5: '提交展位申请表/签订展位合同',
      n6: '支付合同展位订金',
      t1: '沟通需求',
      i1: '参展企业预留联系方式，项目负责人跟进沟通参展企业展位需求；',
      t2: '提交审核',
      i2: '参展企业与项目负责人确认参展意向后，提交公司名称、产品名称及简介，公司官网、联系人、联系方式等，等待主办资质审核；',
      t3: '展位报价',
      i3: '项目负责人向参展企业提供展会招展函及具体展位价格；',
      t4: '展位图',
      i4_1: '1.已出图展会，提供可选展位图给参展企业选择；',
      i4_2: '2.未出图展会，需提前2-3个月支付展位订金排队等待位置分配；',
      i4_3: '3.紧俏展会，需提前至少6个月排队等待位置分配；',
      t5: '合同签订',
      i5: '参展企业与组展单位签订展位合同，一式两份盖章生效，按合同约定对公打款;',
      t6: '展位相关服务',
      i6: '展位确定后，根据时间推进依次向参展企业收取会刊信息表、展商证、展具租赁、车证等材料；',
      t7: '发票',
      i7: '展会结束后7个工作日开具正式发票；',
      t8: '评价及意见',
      i8: '展会结束后收集参展企业对展会的评价及反馈意见，改进服务；'
    }
  },
  // 客服
  customerService: {
    boothConsultation: '展位咨询',
    exhibitionTicketConsultation: '展会门票咨询',
    boothSale: '展位销售',
    telephone: '直线',
    mobilePhone: '手机',
    wechat: '专属微信',
    onlineContact: '在线问',
    workTime: '工作时间'
  },
  // 展位价格
  booth: {
    boothPrice: '展位价格',
    standard_booth: '标准展位',
    blank_booth: '光地展位',
    configuration: '配置',
    price: '价格',
    base: '基础',
    viewPrice: '查看价格',
    boothSampleGraph: '展位示意图',
    tip: '仅供参考，以实际展位配置为准',
    viewFloorPrice: '获取底价',
    configInfo1: {
      item1: '地毯',
      item2: '一桌',
      item3: '两（三）椅',
      item4: '一个废纸篓',
      item5: '公司楣板',
      item6: '两（三）个射灯',
      item7: '两（三）面墙板'
    },
    configInfo2: {
      item1: '不含任何设施',
      item2: '遵守展馆限制',
      item3: '需最小起订面积'
    }
  },
  // 参展流程
  exhibitionProcess: {
    name: '参展流程',
    item1: '1.提交公司营业执照',
    item2: '2.提交产品图片及名称',
    item3: '3.接收展会介绍文件及展位图',
    item4: '4.提交展位申请表/签订展位合同',
    item5: '5.支付合同展位订金',
    item6: '6.准备参展'
  },
  // 用户社区
  userCommunity: {
    userCommunity: '用户社区'
  },

  // 资讯模块
  news: {
    information: '资讯',
    latestExhibition: '最新展会',
    latestNews: '最新资讯',
    notMultiple: '不支持多选',
    source: '来源',
    category: '分类',
    unfollowAction: '取消关注',
    followAction: '关注',
    unlikeAction: '取消点赞',
    likeAction: '点赞',
    shareAction: '分享',
    relatedTags: '相关标签',
    copyrightStatement:
      '声明：文章部分图文版权归原创作者所有，不做商业用途，如有侵权，请与我们联系删除',
    industryExhibitions: '行业展会',
    relatedNews: '相关资讯',
    industryNews: '行业资讯',
    wechatScanPrompt: '请使用手机微信扫码关注'
  },
  // 登录模块
  login: {
    linkAccount: '绑定账号',
    inputPhone: '输入手机号',
    bindLogin: '绑定登录',
    loginAction: '登录',
    registerAction: '注册',
    registerNow: '立即注册',
    contactInput: '输入手机号或邮箱',
    verificationCodeInput: '输入验证码',
    loginRegister: '登 录 / 注 册',
    agreementCheck1: '我已阅读并同意',
    agreementCheck2: '第三方商品平台交易服务协议',
    getCode: '获取验证码',
    codeInputPrompt: '请输入你的验证码',
    agreementPrompt: '请阅读并勾选服务协议',
    validContactPrompt: '请输入正确的手机号或邮箱',
    retryCountdown: '秒后获取',
    frequentContactInput: '输入常用手机号或邮箱',
    passwordInput: '输入密码',
    passwordPrompt: '请输入密码',
    expiredRefresh: '已失效,点击刷新',
    qrScanPrompt: '扫码关注',
    instantAccess: '即可登录注册',
    autoRegistration: '首次扫码将自动注册新账号',
    forgotPassword: '忘记密码',
    newPasswordInput: '输入新登录密码',
    resetPasswordAction: '重置密码',
    accountNotRegistered: '该手机号或邮箱未注册',
    invalidParameters: '参数不合法',
    wechatLogin: '微信扫码登录或注册',
    smsLogin: '手机/邮箱验证码登录',
    passwordLogin: '密码登录',
    accountLoginOption: '账号登录在这里',
    qrLoginOption: '扫码登录在这里'
  },

  // 个人中心模块
  personal: {
    avatar: '头像',
    left: {
      fans: '粉丝',
      follow: '关注',
      personal_center: '个人中心',
      my_order: '我的订单',
      my_exhibition: '我的展会',
      my_vote: '我的门票',
      my_visa: '我的签证',
      my_hotel: '我的酒店',
      my_planeTicket: '我的机票',
      exhibitor_list: '展商名录',
      exhibitions_followed: '关注的展会',
      authentication: '企业认证',
      change_password: '修改密码'
    },
    right: {
      // 个人中心
      follow_industry: '关注的行业',
      add_button: '添加',
      recent: '近期展会',
      distance: '距离开展',
      day: '天',
      ln_progress: '开展中...',
      time_updating: '时间更新中......',
      modify_info: '修改个人资料',
      head_sculpture: '头像',
      prompt: '点击图片替换头像',
      user_name: '用户名',
      user_placeholder: '请输入用户名(必填)',
      gender: '性别',
      gender_placeholder: '请选择性别(必选)',
      male: '男',
      female: '女',
      corporate_name: '公司名称',
      corporate_plader: '请输入公司名称(必填)',
      main_products: '主营产品',
      main_placeholder: '请输入公司产品(必填)',
      company_website: '公司网址',
      company_plader: '请输入公司名称(选填)',
      duties: '职务',
      duties_plader: '请输入职务(必填)',
      email: '邮箱',
      email_plader: '请输入邮箱(选填)',
      confirm_button: '确认',
      modifyInfo_inputRule1: '请输入用户名.',
      modifyInfo_inputRule2: '请选择性别.',
      modifyInfo_inputRule3: '昵称不能是手机号、电话号、邮箱或包含特殊字符',
      modifyInfo_inputRule4: '请输入公司名称.',
      modifyInfo_inputRule5: '请输入公司产品',
      modifyInfo_inputRule6: '请输入职位.',
      // 我的展会
      applied_for: '我申请过的展会',
      participate: '参展公司',
      exhibit_content: '展品内容',
      booth_type: '展位类型',
      booth_area: '展位面积',
      processed: '已处理',
      pending: '待处理',
      raw_sace: '光地展位',
      standard_booth: '标准展位',
      advanced_booth: '进阶展位',
      // 我的门票
      my_vote: '我的门票',
      whole: '全部',
      tobepaid: '待支付',
      issue_tickets: '出票中',
      stop_tickets: '已出票',
      refunded: '已退款',
      // 我的签证
      my_visa: '我的签证',
      // 我的酒店
      my_hotel: '我的酒店',
      // 我的机票
      my_plane_ticket: '我的机票',
      closed: '已关闭',
      // 展商名录
      order_num: '订单编号',
      create_time: '创建时间',
      electronic_journal: '展商名录/电子会刊',
      ear_of_publication: '会刊年份',
      journal_name: '会刊名称',
      notes1:
        '备注：展商名录/电子会刊将在1-2个工作日内以电子邮件形式发送至申请人邮箱，请注意查收(如未收到请查看垃圾邮箱或联系0571-88560061)',
      notes2: '在线展商名录仅支持浏览，不发邮件，不支持复制文字等内容',
      refer_to_button: '查阅会刊',
      state_button1: '开发票',
      state_button2: '开发票中',
      state_button3: '查看发票',
      order_status1: '未支付',
      order_status2: '已申请',
      order_status3: '已支付',
      order_status4: '已完成',
      // 关注的展会
      correct_follow: '已关注',
      deny_follow: '关注',
      follow_exhibition: '关注展会',
      industry_follow: '关注行业',
      launch_time: '还有',
      launch_time_day: '天',
      open_develop: '开展中',
      nextterm_time_renew: '下届时间更新中',
      view_details: '查看详情',
      other_user_box1: '其他一些推荐',
      other_user_box2: '的用户',
      recommend_exhibition: '推荐展会',
      ETag_status1: '普通',
      ETag_status2: '时间变更',
      ETag_status3: '变更',
      ETag_status4: '取消',
      // 企业认证
      account_login: '账号登录:',
      auth_corporate: '公司名称:',
      your_corporate: '您的公司名称',
      english_name: '英文名称',
      your_english_name: '您的公司英文名称',
      corporate_address: '公司地址:',
      select_address: '请选择地址',
      indetail_address: '详细地址:',
      where_address: '所在公司地址',
      corporate_introduce: '公司介绍:',
      introduce: '介绍',
      corporate_phone: '公司电话',
      registered_capital: '注册资金:',
      select_capital: '请选择企业注册资金',
      capital_option1: '100万以下',
      capital_option2: '100-500万',
      capital_option3: '500万-1000万',
      capital_option4: '1000万-3000万',
      capital_option5: '3000万以上',
      staff_num: '员工人数:',
      select_staff_num: '请选择员工人数',
      staff_num_option1: '10-30人',
      staff_num_option2: '30-50人',
      staff_num_option3: '50-100人',
      staff_num_option4: '100人以上',
      service_area: '服务区域:',
      delete: '删除',
      contacts: '联系人:',
      Enter_contacts: '请输入联系人',
      mobile_phone: '手机号:',
      Enter_phone: '请输入手机号',
      Enter_qq: '请输入qq',
      WeChat: '微信:',
      Enter_WeChat: '请输入微信',
      mailbox: '邮箱:',
      Enter_mailbox: '请输入邮箱',
      position: '职位:',
      Enter_position: '请选择职位',
      position_option1: '普通员工',
      position_option2: '经理',
      position_option3: '总经理',
      position_option4: '董事长',
      id_card: '身份证:',
      business_license: '营业执照:',
      qualifications: '公司资质:',
      corporate_photos: '企业照片:',
      enterprise_video: '企业视频:',
      select_video: '选择视频',
      video_size_limit: '视频大小不能大于 10 M',
      submit_authenti: '提交认证',
      // 修改密码
      login_account: '登录账号:',
      message_code: '短信验证码:',
      new_password: '新密码:',
      submit: '提交',
      obtain_code: '获取验证码',
      code_cannot_empty: '短信验证码不能为空',
      new_psd_cannot_empty: '新密码不能为空',
      password_tooweak: '密码强度不够',
      second_obtain: '秒后获取',
      param_illegal: '参数不合法'
    }
  },
  // TDK title, description, keyword
  tdk: {
    home: {
      title: '聚展网-展会网_国际展会_展会门票_展会信息服务平台',
      keywords: '展会,博览会,展会门票,展会会刊,交易会,展会信息',
      description:
        '聚展网为您提供专业的展会信息服务,展会门票,展会会刊,展位预定,展会推广,展会行程,展会物流,展会搭建,展位设计,专业观众引流,展会信息触达全球一百多个国家'
    },
    ticket: '门票',
    time: '时间',
    magazine: '会刊',
    address2: '地点',
    jufair: '聚展',
    jufair2: '聚展网',
    fairTime: '展会时间',
    address: '展会地点',
    sponsor: '主办方',
    // 展会详情页
    exhibitionDetail: {
      description: '聚展网提供展会门票和展位预订服务',
      keyword1: '展',
      keyword2: '展时间',
      keyword3: '展门票',
      keyword4: '展展位图',
      keyword5: '展价格'
    }
  },
  // 展会门票
  fairTicket: {
    selectTicketType: '选择门票类型',
    confirmTicketDetails: '确认门票信息',
    payment: '支付门票订单',
    receiveETicket: '收取电子门票',
    exhibitionTickets: '展会门票',
    viewExhibitions: '查看展会',
    exhibitionDates: '展会时间',
    viewMap: '查看地图',
    organizer: '主办单位',
    venue: '举办展馆',
    hallNumber: '展馆号',
    venueAddress: '举办地址',
    ticketType: '门票类型',
    eTicket: '电子票',
    fullEventPass: '展期票',
    singleDayTicket: '单日票',
    freeAdmission: '免费',
    limitedTimeOffer: '限时',
    soldOut: '暂缺',
    discounted: '折',
    RMB: '元',
    deliveryMethod: '配送方式',
    'selectCompany/individual': '选择公司/个人',
    company: '公司',
    individual: '个人',
    visitor: '观展人',
    addVisitor: '新增观展人',
    ticketPreview: '门票示意图',
    businessLicense: '营业执照',
    businessLicenseSample: '营业执照示例',
    completeProfile: '去完善资料',
    fullName: '姓名',
    gender: '性别',
    male: '男',
    female: '女',
    jobTitle: '职位',
    mobileNumber: '手机号',
    email: '邮箱',
    idType: '证件类型',
    idNumber: '证件号',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    agreeSubmit: '同意以上协议并提交订单',
    basicInfo: '展会基本信息',
    chineseName: '中文名',
    location: '举办地点',
    abbreviation: '简称',
    visitorCount: '观众数量',
    exhibitorCount: '展商数量',
    exhibitionIntro: '展会简介',
    onSitePhotos: '现场图片',
    moreTickets: '更多展会门票',
    clickToBuy: '点击购买',
    orderAmount: '订单金额',
    modifyOrder: '返回修改订单',
    alipay: '支付宝',
    wechatPay: '微信支付',
    redirectToAlipay: '点击“去支付”，跳转到支付宝付款',
    scanWechatQR: '点击“去支付”，打开手机微信“扫一扫”，扫描二维码支付',
    proceedToPay: '去支付',
    paymentSecurity: '聚展支付安全承诺',
    preRegistrationTickets: '预登记门票',
    deliveryTickets: '快递票',
    eInvoice: '电子发票',
    notes: '注意事项',
    serviceFee: '服务费',
    vat: '增值税',
    promotion: '促销优惠',
    totalAmount: '总额',
    limitedTimeFree: '限时免费',
    feeInclusion: '（含：增值税，服务费）',
    imageRequirements: '仅支持尺寸大于600*800，文件大小小于2M的图片',
    ticketingTerms: '购票须知',
    ticketGuidelines:
      '购票成功后，打开网站/小程序出示门票二维码，请携带购票时填写的证件原件验证入场，最终地址以展会现场实际为准。',
    entryInstructions:
      '门票预订成功后，请携带观展人本人身份证原件刷卡入场或至现场服务台换领纸质进馆证！',
    entryProcedure:
      '门票预订成功后，请携带观展人本人护照原件及电子门票至现场服务台或自助机换领进馆证入场！',
    eventUpdatesNotice:
      '展会时间变更或取消，将统一发送短信及邮件提醒观展人，更新的时间也将通过短信及邮件及时通知，请注意查阅！也可通过关注聚展小程序或公众号接收提醒！',
    feeCoverage:
      '费用含门票费、代订服务费，具体明细见价格明细展示，提供门票出票、展会时间变更或取消通知，展会举办地址变更、会议提醒等服务。',
    ticketUsagePolicy: '门票为申请人本人使用，不能转借他人。电子门票可在展馆服务台换领纸质进馆证。',
    ticketPurchaseNotice:
      '请观众在购票时留意所购电子门票的参观日期和进场时间，售出后不可退票、换票，不可转赠，请妥善保存。',
    audienceScope:
      '该展为B2B展，针对专业人士开放，提交申请后需要通过审核，审核过程中我司有权要求申请者补充相关辅助性材料。',
    refundPolicy: '如提交信息不符合审核要求或审核时间截止不能出票的，将在3个工作日原路退回费用。',
    privacyConsent1: '我同意根据本',
    privacyConsent2: '《隐私条例》',
    privacyConsent3: '保留我的个人数据',
    wechatScanPayment: '打开手机微信“扫一扫”，扫描二维码支付',
    visitorRealNameSystem: '参观人员需展会实名制',
    bookingPurpose: '为减少展会现场排队及人员集聚接触，预约成功后会以短信、微信或邮件的形式推送',
    ticketStatus: '无票状态',
    bookingStatus: '暂未开放在线预约门票服务',
    bookingClosed: '已截止在线预约门票服务',
    refundPolicy2: '不支持退',
    ticketNature:
      '票品为有价证券，非普通商品，其背后承载的文化服务具有时效性，稀缺性等特征，不支持退换',
    realNamePolicy: '实名制观展',
    ticketingRule: '本项目需实名制购票及入场，观展请本人携带购票时填写证件验证入场',
    electronicTickets:
      '电子票：通过票夹中的二维码或身份证，可以直接验票入场（具体以下单后票夹信息为准）',
    courierTickets:
      '快递票：纸质票会在开票后快递到您留下的收货地址，需您承担邮寄费用。注:离开展时间仅3天时，不再客送快递票，支持在指定取票地点取票(具体以下单后票夹信息为准)',
    invoiceTiming:
      '该项目支持开具电子发票，请您在展出开始前通过订单页补开，发票将在展出结束后1个月左右，统一由主办方提供',
    companyName: '公司名称',
    attendeeName: '姓名',
    companyNameInput: '请输入公司名称',
    nameInput: '请输入姓名',
    confirmButton: '确 定',
    cancelButton: '取 消',
    addAttendee: '新增观展人信息',
    genderSelection: '请选择性别',
    positionSelection: '请选择职位',
    generalStaff: '普通员工',
    manager: '经理',
    generalManager: '总经理',
    chairman: '董事长',
    phoneNumberLabel: '参展人手机号（用于接收短信通知）',
    emailLabel: '参展人邮箱（用于接收通知）',
    idTypeLabel: '请选择证件类型',
    idCard: '身份证',
    passport: '护照',
    hkMacaoPass: '港澳居民来往内地通行证',
    taiwanPass: '台湾居民来往内地通行证',
    idNumberInput: '请输入证件号',
    departmentLabel: '部门',
    marketingDept: '市场部',
    operationsDept: '运营部',
    adminDept: '管理部',
    procurementDept: '采购部',
    companyTypeLabel: '贵公司所属类型(最多选三个)',
    otherOption: '其他',
    industryServedLabel: '贵公司服务于哪个行业(最多选三个)',
    productInterestLabel: '阁下感兴趣的产品是: (多选)',
    imageSizeLimit: '仅支持文件大小小于2M的图片',
    idFrontExample: '身份证正面示例',
    passportFrontExample: '护照正面示例',
    hkMacaoFrontExample: '港澳居民来往内地通行证正面示例',
    taiwanFrontExample: '台湾居民来往内地通行证正面示例',
    idBackExample: '身份证反面示例',
    passportBackExample: '护照反面示例',
    hkMacaoBackExample: '港澳居民来往内地通行证反面示例',
    taiwanBackExample: '台湾居民来往内地通行证反面示例',
    iDPhotos: '证件照',
    portraitRequirement: '仅支持尺寸大于600*800，文件大小小于2M的图片',
    avatarExample: '头像示例',
    businessCardLabel: '名片',
    businessCardExample: '名片示例'
  },
  // 下载海报
  poster: {
    shareTitle: '分享',
    download: '下载',
    welcome: '欢迎您',
    invitation: '诚挚邀请您参观',
    session: '第{num}届',
    scanQrCode: '长按识别获取参观门票',
    cancel: '取 消',
    downloadSuccess: '下载成功!'
  },
  // 支付结果
  result: {
    ticketInfo: '门票信息',
    ticket_generating: '出票中',
    free_ticket: '免费门票',
    purchase_success: '购买成功',
    periodicalInfo: '期刊信息',
    youMayNeedServices: '您可能还需要如下服务，可在下方添加',
    youMayNeedMoreServices: '您可能还需要以下服务',
    safeTravel: '放心出行',
    securityReminder: '安全提醒',
    weWontLeakInfo:
      '我们不会因任何理由泄露用户信息。如遇陌生号码发送的展会变动、订单异常等信息，切勿轻信，谨防诈骗！',
    electronicPeriodical: '电子会刊｜展商名录',
    clickToView: '点击查看',
    myTickets: '我的门票',
    continueToBuy: '继续购买',
    generatePoster: '生成海报',
    notBookedHotel: '还未预订酒店',
    goToBook: '去预订',
    notAppliedVisa: '还未办理签证',
    goToApply: '去办理',
    subscribeMiniProgram: '关注微信小程序获取电子门票',
    subscribeOfficialAccount: '关注微信公众号获取电子门票',
    bookSuccess: '预订成功',
    bookFailed: '预订失败',
    bookNow: '立即预订',
    visa_application: '签证申请',
    express_handling: '加急办理',
    professional_customer_service: '专业客服',
    itinerary_customization: '行程定制',
    business_itinerary: '商务行程',
    personalized_customization: '个性定制',
    thoughtful_service: '贴心服务',
    success_desc:
      '展会将于 {lunchTime} 举办。请携带身份证原件刷卡入场或至现场服务台换领纸质进馆证！祝您观展顺利！',
    failure_desc: '非常抱歉，您的预订失败了。请重新下单或联系客服寻求帮助。'
  },
  // 会展中心
  pavilion: {
    name: '会展中心',
    filters: {
      region: '地区',
      all: '全部',
      china: '中国',
      nation: '国家',
      more: '更多',
      packUp: '收起'
    },
    total: '共',
    stripStadium: '条场馆',
    recommendedExhibition: '推荐展会',
    more: '更多',
    countryAndRegion: '国家地区',
    pavilionAddress: '场馆地址',
    pavilionArea: '场馆面积',
    squareMeter: '平方米'
  },
  pavilionDetail: {
    home: '首页',
    exhibitionCenters: '会展中心',
    hostVenue: '举办展馆',
    venueArea: '场馆面积',
    squareMeter: '平方米',
    viewMap: '查看地图',
    countryRegion: '国家地区',
    contactPhone: '联系电话',
    officialWebsite: '官网地址',
    venueDetails: '展馆详情',
    exhibitionSchedule: '展会排期',
    all: '全部',
    currentYear: '当年',
    nextYear: '明年',
    otherInformation: '其他信息',
    floorPlan: '平面图',
    relatedExhibitions: '相关展会',
    more: '更多',
    daysUntilExhibition: '距离开展还有',
    days: '天',
    exhibitionInProgress: '开展中...',
    timeUpdating: '时间更新中......'
  }
}
